import { FaceMeasurements } from '@ca/common/types'
import { MeasurementResult } from '@modules/brillen-sdk'

const parseStringRes = (str: string) => {
  const val = str.replace('mm', '').trim()
  const parsed = Number(val)
  if (!Number.isFinite(parsed)) {
    return 0
  }
  return parsed
}

const parseSH = (sh?: string) => {
  if (!sh) {
    console.warn('Missing SH value')
    return 0
  }
  const parsed = parseStringRes(sh)
  return parsed
}

const parsePdMeasurement = (data: FaceMeasurements) => {
  return {
    left: parseStringRes(data.farPD.leftPD),
    right: parseStringRes(data.farPD.rightPD),
  }
}

const parsePdResult = (e: MeasurementResult) => {
  if (e.raw) {
    return e.raw
  }
  return parsePdMeasurement(e.faceData.faceMeasurements)
}

const parseShMeasurement = (data: FaceMeasurements) => {
  return {
    left: parseStringRes(data.segmentHeight.leftSH),
    right: parseStringRes(data.segmentHeight.rightSH),
  }
}

const parseShMeasurementOrEmpty = (
  data: FaceMeasurements | undefined | null
) => {
  if (!data) return { left: undefined, right: undefined }
  return parseShMeasurement(data)
}

const parseShResult = (e: MeasurementResult) => {
  if (e.raw) {
    return e.raw
  }
  return parseShMeasurement(e.faceData.faceMeasurements)
}

const MeasurementUtils = {
  stringRes: parseStringRes,
  parse: {
    pd: {
      result: parsePdResult,
      measurements: parsePdMeasurement,
    },
    sh: {
      measurements: parseShMeasurement,
      measurementsOrEmpty: parseShMeasurementOrEmpty,
      result: parseShResult,
      value: parseSH,
    },
  },
}

export default MeasurementUtils
